import {
  ADD_APPLIED_COMP_CARD,
  CLEAR_SEARCH_COMP_CARDS,
  RESET_APPLIED_COMP_CARDS,
  DELETE_APPLIED_COMP_CARD,
  SEARCH_COMP_CARDS,
  SEARCH_COMP_CARDS_FULFILLED,
  SEARCH_COMP_CARDS_REJECTED,
  SYNC_APPLIED_COMP_CARD,
  UPDATE_APPLIED_COMP_CARD,
} from './types';

export function searchCompCards(value, options) {
  return {
    type: SEARCH_COMP_CARDS,
    payload: {
      value,
      options,
    },
  };
}

export function searchCompCardsFulfilled(selectedCompCard) {
  return {
    type: SEARCH_COMP_CARDS_FULFILLED,
    payload: {
      selectedCompCard,
    },
  };
}

export function searchCompCardsRejected(error) {
  return {
    type: SEARCH_COMP_CARDS_REJECTED,
    payload: error,
  };
}

export function clearCompCardSearch() {
  return {
    type: CLEAR_SEARCH_COMP_CARDS,
  };
}

export function addAppliedCompCard(cardNumber, appliedCompDiscounts) {
  return {
    type: ADD_APPLIED_COMP_CARD,
    payload: {
      cardNumber,
      appliedCompDiscounts,
    },
  };
}

export function deleteAppliedCompCard(cardNumber) {
  return {
    type: DELETE_APPLIED_COMP_CARD,
    payload: cardNumber,
  };
}

export function updateAppliedCompCard(cardNumber, appliedCompDiscounts) {
  return {
    type: UPDATE_APPLIED_COMP_CARD,
    payload: {
      cardNumber,
      appliedCompDiscounts,
    },
  };
}

export function syncAppliedCompCards(compCard, appliedCompDiscounts) {
  return {
    type: SYNC_APPLIED_COMP_CARD,
    payload: {
      compCard,
      appliedCompDiscounts,
    },
  };
}

export function resetAppliedCompCards() {
  return {
    type: RESET_APPLIED_COMP_CARDS,
  };
}
